<template>
  <v-row
    class="list--bordered py-1"
    no-gutters
    align="center"
  >
    <v-col>
      <div class="font-weight-bold">
        {{ equipmentPack.label }}
      </div>
      <div
        v-if="equipmentPack.supplier"
        class="caption"
      >
        Supplier: {{ equipmentPack.supplier.name }}
      </div>
    </v-col>
    <v-col
      class="shrink"
    >
      <v-btn
        v-if="!equipmentPack.ordered"
        text
        small
        color="grey"
        :disabled="!$can('set-eqpack-ordered-status', 'Yacht')"
        class="text-capitalize"
        @click="toggleEquipmentPackOrdered(true)"
      >
        <v-icon
          left
          small
        >
          close
        </v-icon>
        Not Ordered
      </v-btn>
      <v-btn
        v-else
        small
        rounded
        color="green"
        :disabled="!$can('set-eqpack-ordered-status', 'Yacht')"
        dark
        class="text-capitalize"
        @click="toggleEquipmentPackOrdered(false)"
      >
        <v-icon
          left
          small
        >
          check
        </v-icon>
        Ordered
      </v-btn>
    </v-col>
    <v-col
      class="shrink"
    >
      <v-btn
        v-if="!equipmentPack.installed"
        text
        small
        color="grey"
        :disabled="!$can('set-eqpack-ordered-status', 'Yacht')"
        class="text-capitalize"
        @click="toggleEquipmentPackInstalled(true)"
      >
        <v-icon
          left
          small
        >
          close
        </v-icon>
        Not Installed
      </v-btn>
      <v-btn
        v-else
        small
        rounded
        color="green"
        :disabled="!$can('set-eqpack-installed-status', 'Yacht')"
        dark
        class="text-capitalize"
        @click="toggleEquipmentPackInstalled(false)"
      >
        <v-icon
          left
          small
        >
          check
        </v-icon>
        Installed
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
  import Yacht from '@/models/Yacht'

  export default {
    name: 'EquipmentPackInstalledRow',
    props: {
      equipmentPackId: {
        type: Number,
        required: true
      },
      allEquipmentPacks: {
        type: Array,
        required: true
      },
      yacht: {
        type: Object,
        required: true
      }
    },
    computed: {
      equipmentPack() {
        return this.allEquipmentPacks.find(ep => ep.id === this.equipmentPackId)
      }
    },
    methods: {
      async toggleEquipmentPackOrdered(ordered) {
        let response = await Yacht.api.toggleEquipmentPackOrdered(this.yacht.id, this.equipmentPackId, ordered)

        if (!response.success) return

        this.$emit('update:all-equipment-packs', response.yacht.equipment_packs)
      },
      async toggleEquipmentPackInstalled(installed) {
        let response = await Yacht.api.toggleEquipmentPackInstalled(this.yacht.id, this.equipmentPackId, installed)

        if (!response.success) return

        this.$emit('update:all-equipment-packs', response.yacht.equipment_packs)
      }
    }
  }
</script>

<style scoped>

</style>
